module.exports = __webpack_public_path__ + "static/media/buy1.fb21ad05.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/buy1.png
// module id = 1220
// module chunks = 0